export default __webpack_public_path__ + "static/media/Community-living-KID-2025.7a283764.pdf";